import { Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CoreButton } from '../../../_core/components/_ui/core-button';
import { CoreModal, CoreModalProps } from '../../../_core/components/_ui/core-modal';
import { mainTitleModalWindowStyles } from '../../../_core/styles';
import { ReminderConfirmTable } from '../reminder-error-table/remonder-confirm-table.component';

export type ReminderConfirmModalProps = CoreModalProps & {
	data: { engagementId: string; familyId?: string; message: string }[];
	closeModal(): void;
};

export const ReminderConfirmModal: React.FC<ReminderConfirmModalProps> = (props) => {
	const { data, closeModal, ...modalProps } = props;
	const [t] = useTranslation();

	return (
		<CoreModal
			modalWidth={600}
			{...modalProps}
			bodySx={{ pt: 0, display: 'flex', gap: 3, flexDirection: 'column' }}
			paperSx={{ width: '100%' }}
		>
			<Box sx={{ display: 'flex', gap: 3, flexDirection: 'column', alignItems: 'center' }}>
				<Typography variant="h5" sx={{ fontSize: '24px', fontWeight: 500 }}>
					{' '}
					{'Reminder set confirmation'}
				</Typography>
				<Typography>Below is the list of engagements with reasons why reminder can't be set</Typography>
			</Box>
			<Box>
				<ReminderConfirmTable loading={false} data={data} reminderConfirmColumnsList={[]} />
			</Box>
			<Box
				sx={[
					{ display: 'flex', justifyContent: 'center' },
					({ breakpoints }) => ({
						[breakpoints.down('sm')]: {
							flexDirection: 'column-reverse',
							alignItems: 'center',
						},
					}),
				]}
			>
				<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: 3 }}>
					<CoreButton onClick={closeModal} variant="secondary">
						{t('families.forms.buttons.cancel')}
					</CoreButton>

					<CoreButton contraModeStyleButton onClick={closeModal}>
						{t('engagements.forms.buttons.confirm')}
					</CoreButton>
				</Box>
			</Box>
		</CoreModal>
	);
};
